export const DEFAULT_AMOUNT = 10;
export const DEFAULT_MIN_AMOUNT = 0.5;
export const DEFAULT_MAX_AMOUNT = 10000;
export const CHECKOUT_STATE_CHECK_TIMEOUT = 1000 * 30;
